import FreelancerProfile from './FreelancerProfile';
export default FreelancerProfile;
